import { FC } from "react";
import { Flex, Group, Stack, Text } from "@mantine/core";

import { ReactComponent as MapIcon } from "assets/map.svg";
import { ReactComponent as UserIcon } from "assets/user2.svg";
import { ReactComponent as RoutesIcon } from "assets/routes.svg";
import { ReactComponent as CurrencyCircleDollarIcon } from "assets/CurrencyCircleDollar.svg";
import { ReactComponent as ChatIcon } from "assets/Chats.svg";

import ColorLabel from "../ColorLabel";
import { ColorType } from "../FunnelMenu/ColorsPanel";

import styles from "./FooterMenu.module.scss";

export type FooterMenuViewType = 
  "MAP" | "PRACTITIONER_LIST" | "OPPSANDRISKS" | "ROUTES" | "HOME";

interface Props {
  isDesktop?: boolean;
  view?: FooterMenuViewType;
  isColorLabelVisible: boolean;
  colorControl?: ColorType;
  minScale: number;
  maxScale?: number;
  onViewChange: (v: FooterMenuViewType) => void;
}

const FooterMenu: FC<Props> = ({
  isDesktop = false,
  view,
  isColorLabelVisible,
  colorControl,
  minScale,
  maxScale,
  onViewChange,
}) => {
  return (
    <Flex bg="#4F7D9C" w="100vw" h={70} gap={10} className={styles.wrapper}>
      <Group
        bg="#4F7D9C"
        w={isDesktop ? "50%" : "100%"}
        h={70}
        justify={isDesktop ? "flex-start" : "space-around"}
        align="center"
        gap={15}
        style={{
          zIndex: 1000,
          boxSizing: 'border-box',
        }}
      >
        {isDesktop ? (
          <>
            <Stack w={50} gap={4} align="center" c="white"
              onClick={() => onViewChange("HOME")}>
              <ChatIcon width={24} height={24} />
              <Text fz={8} fw={700}>AI</Text>
            </Stack>
            <Stack w={50} gap={4} align="center"
              c={view === "PRACTITIONER_LIST" ? "#FF9D00" : "white"}
              onClick={() => onViewChange("PRACTITIONER_LIST")}>
              <UserIcon width={24} height={24} />
              <Text fz={8} fw={700}>Practitioners</Text>
            </Stack>
            <Stack w={50} gap={4} align="center"
              c={view === "ROUTES" ? "#FF9D00" : "white"}
              onClick={() => onViewChange("ROUTES")}>
              <RoutesIcon width={24} height={24} />
              <Text fz={8} fw={700}>Routes</Text>
            </Stack>
            <Stack w={50} gap={4} align="center"
              c={view === "OPPSANDRISKS" ? "#FF9D00" : "white"}
              onClick={() => onViewChange("OPPSANDRISKS")}>
              <CurrencyCircleDollarIcon width={24} height={24} />
              <Text fz={8} fw={700}>Opps/Risks</Text>
            </Stack>
          </>
        ) : (
          <>
            <Stack w={52} gap={4} align="center"
              c={view === "MAP" ? "#FF9D00" : "white"}
              onClick={() => onViewChange("MAP")}>
              <MapIcon width={24} height={24} />
              <Text fz={8} fw={700}>
                Territory Map
              </Text>
            </Stack>
            <Stack w={50} gap={4} align="center"
              c={view === "PRACTITIONER_LIST" ? "#FF9D00" : "white"}
              onClick={() => onViewChange("PRACTITIONER_LIST")}>
              <UserIcon width={24} height={24} />
              <Text fz={8} fw={700}>Practitioners</Text>
            </Stack>
            <Stack w={50} gap={4} align="center" c="white"
              onClick={() => onViewChange("HOME")}>
              <ChatIcon width={24} height={24} />
              <Text fz={8} fw={700}>AI</Text>
            </Stack>
            <Stack w={50} gap={4} align="center"
              c={view === "ROUTES" ? "#FF9D00" : "white"}
              onClick={() => onViewChange("ROUTES")}>
              <RoutesIcon width={24} height={24} />
              <Text fz={8} fw={700}>Routes</Text>
            </Stack>
            <Stack w={50} gap={4} align="center"
              c={view === "OPPSANDRISKS" ? "#FF9D00" : "white"}
              onClick={() => onViewChange("OPPSANDRISKS")}>
              <CurrencyCircleDollarIcon width={24} height={24} />
              <Text fz={8} fw={700}>Opps/Risks</Text>
            </Stack>
          </>
        )}
      </Group>
      {colorControl && isDesktop && (
        <Flex align="center" w="50%">
          <ColorLabel
            isVisible={isColorLabelVisible}
            colorControl={colorControl}
            minScale={minScale}
            maxScale={maxScale as number}
            showBorder={false}
            isDesktop
          />
        </Flex>
      )}
    </Flex>
  );
};

export default FooterMenu;